module.exports = __webpack_public_path__ + "img/appAsset--users-ax.a0a121d3.svg";